import "./ProjectHeroTravelSite.scss";

function ProjectHeroTravelSite() {
  return (
    <>
      <section class="project-cs-hero">
        <div class="project-cs-hero__content">
          <h1 class="heading-primary">Travel Site</h1>
          <div class="project-cs-hero__info">
            <p class="text-primary text-primary--project">
              This is a website for an agency that helps with organising travel
              bookings.
            </p>
          </div>
          <div class="project-cs-hero__cta">
            <a
              href="https://supreet-kaur-travelsite.netlify.app/"
              class="btn btn--bg"
              target="_blank"
              rel="noreferrer"
            >
              Live Link
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectHeroTravelSite;
